import { useDispatch } from "react-redux";

import { vorActions } from "slices/vor/vorSlice";
import { downloadFile } from "core/request_utils";
import { isFileNamePdf } from "core/file_utils";

import apiVor from "api/vor";

const useVorFuncs = ({ vorId, setPdfBlobData, setPdfBlobName, setJustPdfVisible, setTargetPage }) => {
	const dispatch = useDispatch();

	const getJust = ({ rowObj, pageTarget }) => {
		dispatch(vorActions.setFetchStatus("loading"));
		setJustPdfVisible(true);
		const prom = apiVor.getJustFile({ vorId, fileId: rowObj.orig_file_id });
		try {
			setTargetPage(parseInt(pageTarget) - 1);
		} catch {}

		prom.then((response) => {
			if (isFileNamePdf({ fileName: rowObj.quantityformula })) {
				setPdfBlobName(rowObj.quantityformula);
				setPdfBlobData(response.data);
				setJustPdfVisible(true);
			} else {
				downloadFile(response);
			}
			dispatch(vorActions.setFetchStatus("success"));
		}).catch((error) => {
			if (error?.response?.status === 400) {
				dispatch(vorActions.setFetchStatusText("Запрошенное обоснование не загружено на сервер"));
				dispatch(vorActions.setFetchStatus("failed"));
			} else {
				dispatch(vorActions.setFetchStatus("success"));
			}
		});
	};

	return { getJust };
};

export default useVorFuncs;
